import { Box, Typography, Button } from '@mui/material';
import HistoryDateControl from '../../../dynamictabs/HistoryDateControl';
import { useHMapContext } from '../../hooks/useHMapContext';
import { heatmapCustomEvents } from '../../const/HMapEvents';
import React from 'react';
import HMapDisplayTabs from './HMapDisplayTabs';

const HMapDisplayPanel = ({ setCurrentPanel }) => {
  const { history, requestStatusInfo, currentMapInfo } = useHMapContext();
  const [status] = requestStatusInfo;
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0
      }}
    >
      <Box
        component="section"
        aria-label="Heatmap date"
        sx={{ px: 2, pb: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Heatmap date
        </Typography>
        <HistoryDateControl {...history} onChange={history.setDate} />
        {status === 'loading' && (
          <Typography role="status">Loading heatmap...</Typography>
        )}
        {status === 'error' && (
          <Box role="alert">
            Unable to load heatmap.{' '}
            <Button
              onClick={() =>
                document.dispatchEvent(
                  new CustomEvent(heatmapCustomEvents.START_SEARCH, {
                    detail: { currentMap: currentMapInfo[0] }
                  })
                )
              }
            >
              Retry
            </Button>
          </Box>
        )}
      </Box>
      <HMapDisplayTabs setCurrentPanel={setCurrentPanel} />
    </Box>
  );
};

export default React.memo(HMapDisplayPanel);
